<template>
  <common-dialog ref="dialog" width="600px" title="回收结果" :data="data" @closed="onClosed">
    <template slot="form">
      <div class="head-box">
        成功：
        <span style="color: #67C23A;">{{ data.success }}</span>
        个，失败：
        <span style="color: #F56C6C;">{{ data.error.length }}</span>
        个
      </div>
      <el-table :data="data.error" border>
        <el-table-column prop="waybillCode" label="面单号" width="200" />
        <el-table-column prop="msg" label="错误信息" min-width="300" />
      </el-table>
    </template>
    <template slot="footer">
      <el-button @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import dialogMixin from '@/mixins/dialog';
import commonDialog from '@/components/common/dialog';

export default {
  mixins: [dialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        success: 0,
        error: []
      }
    };
  },
  methods: {
    setData(data) {
      console.log("data", data);
      this.data = { ...data };
    },
    onClosed() {
      this.$emit("closed")
    }
  },
};
</script>
<style lang="scss" scoped>
.head-box {
  line-height: 40px;
  padding-left: 10px;
  border: 1px solid #EBEEF5;
  border-bottom: none;
}
</style>